import AdminInterface from "../components/Admin";

const AdminPage = () => {
    return (
        <AdminInterface />
    );
};

export default AdminPage;